import intro from '../pages/intro/page.js';
import outro from '../pages/outro_fact/page.js';
import game from '../pages/this_or_that/page.js';

let parent;
let _clb;

const intro_page=()=>intro.show({
	cls:'bike',
	header:'This or that',
	desc:[
		'Today, you\'re going to ride your bike through the old streets of Savannah.',
		'Remember to make safe choices while biking.'
	],
	clb:game_page,
	parent
});

const game_page=()=>game.show({
	parent,
	clb:outro_page
});

const outro_page=()=>outro.show({
	cls:'this_or_that bike',
	header:'NICE JOB!',
	desc:[
		'You\'ve successfully pedaled your way to the beautiful Savannah waterfront.'
	],
	fact_name:'Remember!',
	fact:'You always ride with the flow of traffic, not against it. So you\'ll be on the right side.',
	parent,
	clb:()=>{
		if(_clb) _clb();
		_clb = undefined;
	}
})

const _ext={
	start:({container,clb})=>{
		parent = container;
		_clb=clb;
		intro_page();
	},
	stop:()=>{
		game.hide();
	}
}

export default _ext;
